var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCaretOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.335.161a.571.571 0 00-.795 0L6.75 5.82.96.16a.571.571 0 00-.795 0 .54.54 0 000 .778l6.187 6.047a.568.568 0 00.796 0L13.335.939a.54.54 0 000-.778z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--caret-outline-cc282a52f8570f1e7cc5e1b8f205cbb2.svg";
export { SvgIconUiCaretOutline as Component };